// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"7ab59288","347":"91ab2cf5","405":"066969e5"}[chunkId] + ".chunk.js";
};